import { ErrorBoundary, componentError, 
    // IconAbajo 
} from "@portal/arq-portal-core"
import React from "react"
import { ResultadoFinanciero } from "./ResultadoFinanciero"
import {
    makeStyles,
    // Accordion,
    // AccordionSummary,
    // AccordionDetails
  } from '@material-ui/core';
const useStyles = makeStyles({
    root: {
      display: 'flex',
      padding: '5px',
      fontSize: 12,
      color: '#6D6D6D',
      justifyContent: 'flex-end',
      marginTop: 10,
      '@media screen and (max-width: 959px)': {
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginTop: 0,
        padding: '0 36px'
      }
    },
    titulo: {
      fontWeight: 'bold',
      color: '#DC0028',
      marginRight: 8,
      display: 'flex',
      alignItems: 'center',
      marginBottom: '2px',
    },
    linea: {
      marginRight: 8,
      display: 'flex',
      alignItems: 'center'
    },
    monto: {
      marginRight: 8,
      display: 'flex',
      alignItems: 'center'
    },
    menuSeccion: {
      display: 'flex',
      marginBottom: '2px',
    },
    positive: {
      position:'relative',
      marginRight: 8,
      '&::before': {
        content: '""',
        width: 0,
        height: 0,     
        borderLeft: '0.4em solid transparent',
        borderRight: '0.4em solid transparent',
        borderBottom: '0.7em solid #14A843',
        marginRight: 3,
        marginBottom: '1px',
      }
    },
    negative: {
      position: 'relative',
      '&::before': {
        content: '""',
        width: 0,
        height: 0,
        borderLeft: '0.4em solid transparent',
        borderRight: '0.4em solid transparent',
        borderTop: '0.7em solid #FF0000',
        marginRight: 3,
        marginBottom: '1px',
      }
    },
    accordion: {
      boxShadow: 'none !important',
      background: 'none !important',
      borderBottom: '1px dashed rgba(0, 0, 0, 0.12)',
      borderRadius: '0 !important',
      paddingBottom: 10,
      paddingTop: 8,
      '@media screen and (min-width: 960px)': {
        display: 'none'
      },
      '& .MuiAccordionDetails-root': {
        padding: 0
      },
      '& .MuiButtonBase-root': {
        height: 32,
        minHeight: 32
      },
      '& .MuiAccordionSummary-root': {
        padding: 0,
        marginLeft: '-10px',
      },
      '& .MuiSvgIcon-root': {
        fontSize: 14
      },
      '& .MuiAccordionSummary-content': {
        marginLeft: 10,
        order: 2,
        fontWeight: 'bold',
        padding: 0,
        fontSize: '14px',
        color: '#606060',
        fontFamily: 'CO-Bold',
      },
      '& .MuiTouchRipple-root':{
        display: 'none',
      },
  
    },
  
  })

export const WrappedResultadoFinanciero = (props:any) => {
    const classes = useStyles();
    
    const resultadoErrorPanel = (
        <div className={classes.root}>
          <div className={classes.titulo}>{componentError.title}</div>
          <div className={classes.menuSeccion}>
            <div className={classes.linea}>{componentError.body}</div>
          </div>
        </div>
      );
    
    return (
        <ErrorBoundary 
            fallback={()=>{ 
                return <React.Fragment>                
                    <div>{resultadoErrorPanel}</div>
                </React.Fragment>
            }}
        >
                <ResultadoFinanciero {...props} />
        </ErrorBoundary>
    )
}